export class StripeSearchOptions{
    public query: string;
    public limit?: number;
    public page?: string;
}